import ResponseObject from "../../DataObjects/ResponseObject";
import http from "../../Store/baseHttp";
import BaseController from "./BaseController";

class CompanyService extends BaseController {
  async index({ request }) {
    const url = new URL(request.url);
    url.searchParams.append("name", url.searchParams.get("search") ?? "");
    try {
      let response = await http.get(
        "/companies" + url.search + "&sort_type=DESC"
      );
      response = ResponseObject.from(response);
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }

  static async view({ request, params }) {
    const url = new URL(request.url);
    url.searchParams.append("name", url.searchParams.get("search") ?? "");
    try {
      let response = await http.get("/companies/" + params.id);
      response = ResponseObject.from(response);
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }

  static async approval({ request, params }) {
    const url = new URL(request.url);
    url.searchParams.append("name", url.searchParams.get("search") ?? "");
    try {
      let response = await http.get("/admin/customers/single/" + params.id);
      response = ResponseObject.from(response);
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }

  static async template({ request, params }) {
    try {
      let response = await http.get("/invoice/template");
      response = ResponseObject.from(response);
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }

  static async email(formData) {
    try {
      let response = await http.post(
        "/admin/staff/onboard/email/resend",
        formData
      );
      response = ResponseObject.from(response);
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }

  async post({ request }) {
    const formData = Object.fromEntries(await request.formData());
    const { anchor, salary_advance, ...companyData } = formData;
    const finalCompanyData = {
      ...companyData,
      service_options: [
        {
          anchor: anchor??null,
        },
        {
          salary_advance: salary_advance??null,
        },
      ],
    };
    // console.log(finalCompanyData)
    try {
      let response = await http.post("/companies", finalCompanyData);
      response = ResponseObject.from(response);
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }

  async put({ request, params }) {
    const formData = Object.fromEntries(await request.formData());
    // console.log(formData.token);
    try {
      let response = await http.put("/companies/" + formData.token, formData);
      response = ResponseObject.from(response);
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }

  async destroy({ request }) {
    const formData = Object.fromEntries(await request.formData());
    try {
      let response = await http.delete(`/companies/${formData.token}`);
      response = ResponseObject.from(response);
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }

  async patch({ request }) {
    const formData = Object.fromEntries(await request.formData());
    try {
      let response = await http.put(`/companies/status/change`, formData);
      response = ResponseObject.from(response);
      return response;
    } catch (e) {
      return ResponseObject.from(e?.response);
    }
  }
}

export default CompanyService;
